<template>
  <div>
    <!-- Link Pay Button -->
    <!-- <v-btn block color="#ccc" size="large" class="mb-4 text-white"> </v-btn> -->

    <h3 class="text-primaryText my-2">Your Info</h3>
    <v-sheet border rounded class="py-4 px-4">
      <div class="font-weight-bold mb-1 text-primaryText">Email</div>
      <v-text-field
        variant=""
        density="comfortable"
        hide-details
        class="mb-4 ma-0 coupon-field-input"
        color="primary"
      >
        <template v-if="loading">
          <div class="skeleton-loader-overlay">
            <v-skeleton-loader
              type="text"
              class="slim-skeleton"
            ></v-skeleton-loader>
          </div>
        </template>
      </v-text-field>
    </v-sheet>

    <!-- Amazon Pay -->
    <!-- <v-card variant="outlined" class="mb-2 pa-3 light-border">
      <v-row align="center">
        <v-col cols="auto">          
        </v-col>
        <v-col>Amazon Pay</v-col>
      </v-row>
    </v-card>

    
    <v-card variant="outlined" class="mb-4 pa-3 light-border">
      <v-row align="center">
        <v-col cols="auto">          
        </v-col>
        <v-col>Cash App Pay</v-col>
      </v-row>
    </v-card> -->

    <!-- Shipping Address -->

    <div class="my-4" style="min-height: unset">
      <h3 class="text-primaryText my-2">Shipping Address</h3>
      <v-sheet border rounded class="pa-4">
        <v-row dense>
          <v-col cols="6">
            <div class="font-weight-bold mb-1 text-primaryText">First name</div>
            <v-text-field
              variant=""
              density="comfortable"
              hide-details
              class="mb-4 ma-0 coupon-field-input"
              color="primary"
            >
              <template v-if="loading">
                <div class="skeleton-loader-overlay">
                  <v-skeleton-loader
                    type="text"
                    class="slim-skeleton"
                  ></v-skeleton-loader>
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <div class="font-weight-bold mb-1 text-primaryText">Last name</div>
            <v-text-field
              variant=""
              density="comfortable"
              hide-details
              class="mb-4 ma-0 coupon-field-input"
              color="primary"
            >
              <template v-if="loading">
                <div class="skeleton-loader-overlay">
                  <v-skeleton-loader
                    type="text"
                    class="slim-skeleton"
                  ></v-skeleton-loader>
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="font-weight-bold mb-1 text-primaryText">Address</div>
            <v-text-field
              variant=""
              density="comfortable"
              hide-details
              class="mb-4 ma-0 coupon-field-input"
              color="primary"
            >
              <template v-if="loading">
                <div class="skeleton-loader-overlay">
                  <v-skeleton-loader
                    type="text"
                    class="slim-skeleton"
                  ></v-skeleton-loader>
                </div>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-sheet>
    </div>

    <!-- Billing Address -->
    <div class="my-4" style="min-height: unset">
      <h3 class="text-primaryText my-2">Billing Address</h3>
      <v-sheet border rounded class="pa-4">
        <v-checkbox
          v-model="sameAsShipping"
          readonly
          color="primaryText"
          hide-details
          density="x-small"
          class="mb-4 mt-2"
        >
          <template v-slot:label>
            <span class="ml-1">Billing is same as shipping information</span>
          </template>
        </v-checkbox>
      </v-sheet>
    </div>

    <!-- Card Section -->
    <div class="my-4" style="min-height: unset">
      <h3 class="text-primaryText my-2">Payment Method</h3>
      <v-sheet border rounded class="pa-4">
        <div class="mb-3 font-weight-bold text-primaryText">Card</div>

        <v-row dense>
          <v-col cols="12">
            <div
              class="font-weight-bold mb-1 text-md-caption text-lg-body-2 text-primaryText"
            >
              Card number
            </div>
            <v-text-field
              variant=""
              density="comfortable"
              hide-details
              class="mb-4 ma-0 coupon-field-input"
              color="primary"
            >
              <template v-if="loading">
                <div class="skeleton-loader-overlay">
                  <v-skeleton-loader
                    type="text"
                    class="slim-skeleton"
                  ></v-skeleton-loader>
                </div>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="6">
            <div
              class="font-weight-bold mb-1 text-md-caption text-lg-body-2 text-primaryText"
            >
              Expiration date
            </div>
            <v-text-field
              variant=""
              density="comfortable"
              hide-details
              class="mb-4 ma-0 coupon-field-input"
              color="primary"
            >
              <template v-if="loading">
                <div class="skeleton-loader-overlay">
                  <v-skeleton-loader
                    type="text"
                    class="slim-skeleton"
                  ></v-skeleton-loader>
                </div>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="6">
            <div
              class="font-weight-bold mb-1 text-md-caption text-lg-body-2 text-primaryText"
            >
              Security code
            </div>
            <v-text-field
              variant=""
              density="comfortable"
              hide-details
              class="mb-4 ma-0 coupon-field-input"
              color="primary"
            >
              <template v-if="loading">
                <div class="skeleton-loader-overlay">
                  <v-skeleton-loader
                    type="text"
                    class="slim-skeleton"
                  ></v-skeleton-loader>
                </div>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-sheet>
    </div>

    <!-- Pay Button -->
    <v-btn block color="primaryButton" size="large" class="white--text mt-2">
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "StripeSkeleton",
  data() {
    return {
      loading: true,
      sameAsShipping: true,
    };
  },
};
</script>
<style scoped>
.light-border {
  border: 1px solid #ddd !important;
}

.skeleton-loader-overlay {
  position: absolute;
  top: 50%;
  left: 12px;
  right: 12px;
  transform: translateY(-50%);
}

.slim-skeleton .v-skeleton-loader__text {
  height: 10px !important;
  margin: 0 !important;
  background-color: #e0e0e0 !important;
  border-radius: 30px !important;
}
</style>
